export default __webpack_public_path__ + "static/media/clientvenue-logo.a50ab964.png";